import { action } from '@/lib/api';

const clearCredentials = () => {
  action('CLEAR_CREDENTIALS');
};

export default clearCredentials;
